// SolarSim — admin auth helpers (JWT stored in localStorage)
// Note: localStorage is chosen for JWT storage because SolarSim uses a
// bearer-token auth pattern. Migration to httpOnly cookies is tracked as
// future hardening but requires CSRF token + backend cookie plumbing.
// The `solarsim_*` storage keys are kept as-is post-rebrand so that existing
// admin sessions and user preferences (attribution, language, install prompt)
// survive the migration to the SolarSim brand.
import { warn } from "@/lib/logger";

const TOKEN_KEY = "solarsim_admin_token";

export function getToken() {
  try {
    return typeof window !== "undefined" ? window.localStorage.getItem(TOKEN_KEY) : null;
  } catch (err) {
    warn("auth.getToken: localStorage unavailable", err);
    return null;
  }
}

export function setToken(token) {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch (err) {
    warn("auth.setToken: localStorage unavailable", err);
  }
}

export function clearToken() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch (err) {
    warn("auth.clearToken: localStorage unavailable", err);
  }
}

export function isAuthenticated() {
  return Boolean(getToken());
}
